/**
 * Control-test entity strings for the shared Smart Copy code — the single
 * per-entity source of truth a register supplies (keeps the shared code
 * entity-agnostic).
 *
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); 'Control
 *   Test' reproduces the deployed strings.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase); 'test
 *   result' reproduces the deployed wording.
 */
export const CONTROL_TEST_SMART_COPY = {
  eventLabel: 'Control Test',
  entityNoun: 'test result',
} as const;
